import { LoaderHandler } from "planning-portal-library/src/lib/core/domain/models/loader-enabler";
import { Injectable } from "@angular/core";
import { State, Action, StateContext, Selector, select } from "@ngxs/store";
import { append, patch, removeItem } from "@ngxs/store/operators";
import { GridHeader, Job, Plan, Service, Location, MasterPlan, JobDetails } from "../../../core/domain";
import {
  DisableLoading,
  EnableLoading,
  GetGridHeaders, SetBaseRoute,
  SetEntityType,
  SetIsCreated,
  SetIsDeleted,
  SetSelectedGroupId,
  SetSelectedGroupIdForImportLocation,
  SetIsUpdated,
  SetSelectedJobDetailForBreadcrumb,
  SetSelectedJobForBreadcrumb,
  SetSelectedLocationForBreadcrumb, SetSelectedMasterPlanForBreadcrumb,
  SetSelectedPlanDetailForBreadcrumb,
  SetSelectedPlanForBreadcrumb,
  SetSelectedServiceForBreadcrumb,
  SetTotalRecords,
  SetValidatedJLDataForPlan,
  SetMapProviders,
  SetFeatureConfigurations,
  UpdateGridHeaders
} from "./base.actions";
import { PlanJobs } from "planning-portal-library/src/lib/core/domain/models/plan-details";
import { ValidateJLCsvFileResponse } from "planning-portal-library/src/lib/core/domain/requests/plans/ValidateJLCsvFileResponse";
import { MapProvider } from "planning-portal-library/src/lib/core/domain/models/map-provider.model";
import { FeatureConfiguration } from "planning-portal-library/src/lib/core/domain/models/feature-configuration";


export class BaseStateModel {
  entityType: number | undefined;
  gridHeaders: GridHeader[] | undefined;
  totalRecords: number | undefined;
  loading: LoaderHandler[] | undefined;
  isConfigurationUpdated: boolean | undefined;
  isCreated: boolean | undefined;
  isUpdated: boolean | undefined;
  isDeleted: boolean | undefined;
  selectedGroupId: string | undefined;
  selectedGroupIdForImportLocation: string | undefined;
  baseRoute: string | undefined;
  selectedMasterPlanForBreadcrumb: MasterPlan | undefined;
  selectedPlanForBreadcrumb: Plan | undefined;
  selectedJobForBreadcrumb: Job | undefined;  
  validatedJLData:ValidateJLCsvFileResponse|undefined;
  mapProvider:MapProvider[]|undefined;
  featureConfiguration:FeatureConfiguration[]|undefined;
  selectedLocationForBreadcrumb: Location | undefined;
  selectedServiceForBreadcrumb: Service | undefined;
  selectedPlanDetailForBreadcrumb : PlanJobs | undefined;
  selectedJobDetailForBreadcrumb : JobDetails | undefined;
}

const defaults = {
  entityType: undefined,
  gridHeaders: undefined,
  totalRecords: undefined,
  loading: [],
  isConfigurationUpdated: undefined,
  isCreated: undefined,
  isUpdated: undefined,
  isDeleted: undefined,
  selectedGroupId:undefined,
  selectedGroupIdForImportLocation: undefined,
  baseRoute: undefined,
  selectedMasterPlanForBreadcrumb: undefined,
  selectedPlanForBreadcrumb: undefined,
  selectedJobForBreadcrumb: undefined,
  validatedJLData:undefined,
  mapProvider:undefined,
  featureConfiguration:undefined,
  selectedLocationForBreadcrumb: undefined,
  selectedServiceForBreadcrumb: undefined,
  selectedPlanDetailForBreadcrumb : undefined,
  selectedJobDetailForBreadcrumb : undefined
};

@State<BaseStateModel>({
  name: "base",
  defaults
})
@Injectable()
export class BaseState {

  @Action(SetEntityType)
  setEntityType(ctx: StateContext<BaseStateModel>, { payload }: SetEntityType) {
    ctx.setState({ ...ctx.getState(), entityType: payload });
  }

  @Action(GetGridHeaders)
  getGridHeaders(ctx: StateContext<BaseStateModel>, { payload }: GetGridHeaders) {
    ctx.setState({ ...ctx.getState(), gridHeaders: payload });
  }

  @Action(UpdateGridHeaders)
  updateGridHeaders(ctx: StateContext<BaseStateModel>, { payload }: UpdateGridHeaders) {
    ctx.setState({ ...ctx.getState(), isConfigurationUpdated: payload });
  }

  @Action(SetTotalRecords)
  setTotalRecords(ctx: StateContext<BaseStateModel>, { payload }: SetTotalRecords) {
    ctx.setState({ ...ctx.getState(), totalRecords: payload });
  }

  @Action(EnableLoading)
  enableLoading(ctx: StateContext<BaseStateModel>, { payload }: EnableLoading) {
    const loading = ctx.getState().loading ?? [];
    ctx.setState({
      ...ctx.getState(),
      loading: [...loading, payload!],
    });
  }

  @Action(DisableLoading)
  disableLoading(ctx: StateContext<BaseStateModel>, { payload }: DisableLoading) {
    const loading = ctx.getState().loading ?? [];
    ctx.setState({
      ...ctx.getState(),
      loading: loading.filter(
        (item) =>
          !(
            item?.endPointName === payload?.endPointName &&
            item?.componentName === payload?.componentName
          )
      ),
    });
  }

  @Action(SetIsCreated)
  setIsCreated(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isCreated: payload });
  }

  @Action(SetIsUpdated)
  setIsUpdated(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isUpdated: payload });
  }


  @Action(SetIsDeleted)
  setIsDeleted(ctx: StateContext<BaseStateModel>, { payload }: SetIsCreated) {
    ctx.setState({ ...ctx.getState(), isDeleted: payload });
  }

    @Action(SetSelectedGroupId)
  SetSelectedGroupId(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedGroupId) {
    ctx.setState({ ...ctx.getState(), selectedGroupId: payload });
  }

  
    @Action(SetSelectedGroupIdForImportLocation)
  SetSelectedGroupIdForImportLocation(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedGroupIdForImportLocation) {
    ctx.setState({ ...ctx.getState(), selectedGroupIdForImportLocation: payload });
  }

  

  @Action(SetBaseRoute)
  setBaseRoute(ctx: StateContext<BaseStateModel>, { payload }: SetBaseRoute) {
    ctx.setState({ ...ctx.getState(), baseRoute: payload });
  }

  @Action(SetSelectedMasterPlanForBreadcrumb)
  setSelectedMasterPlan(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedMasterPlanForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedMasterPlanForBreadcrumb: payload });
  }

  @Action(SetSelectedPlanForBreadcrumb)
  setSelectedPlan(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedPlanForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedPlanForBreadcrumb: payload });
  }
  @Action(SetValidatedJLDataForPlan)
  setValidatedJLData(ctx: StateContext<BaseStateModel>, { payload }: SetValidatedJLDataForPlan) {
    ctx.setState({ ...ctx.getState(), validatedJLData: payload });
  }

  @Action(SetMapProviders)
  setProvider(ctx: StateContext<BaseStateModel>, { payload }: SetMapProviders) {
    ctx.setState({ ...ctx.getState(), mapProvider: payload });
  }

   @Action(SetFeatureConfigurations)
  setConfigurations(ctx: StateContext<BaseStateModel>, { payload }: SetFeatureConfigurations) {
    ctx.setState({ ...ctx.getState(), featureConfiguration: payload });
  }

  @Action(SetSelectedJobForBreadcrumb)
  setSelectedJob(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedJobForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedJobForBreadcrumb: payload });
  }

  @Action(SetSelectedLocationForBreadcrumb)
  setSelectedLocation(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedLocationForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedLocationForBreadcrumb: payload });
  }

  @Action(SetSelectedServiceForBreadcrumb)
  setSelectedService(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedServiceForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedServiceForBreadcrumb: payload });
  }
  
  @Action(SetSelectedPlanDetailForBreadcrumb)
  selectedPlanDetailForBreadcrumb(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedPlanDetailForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedPlanDetailForBreadcrumb: payload });
  }

  @Action(SetSelectedJobDetailForBreadcrumb)
  selectedJobDetailForBreadcrumb(ctx: StateContext<BaseStateModel>, { payload }: SetSelectedJobDetailForBreadcrumb) {
    ctx.setState({ ...ctx.getState(), selectedJobDetailForBreadcrumb: payload });
  }

  @Selector()
  static GetEntity(state: BaseStateModel) {
    return state.entityType;
  }

  @Selector()
  static GridHeaders(state: BaseStateModel) {
    return state.gridHeaders;
  }
  
  @Selector()
  static getMapProviders(state: BaseStateModel) {
    return state.mapProvider;
  }

   @Selector()
  static selectedLocationGroupId(state: BaseStateModel) {
    return state.selectedGroupId;
  }
     @Selector()
  static selectedGroupIdForImportLocation(state: BaseStateModel) {
    return state.selectedGroupIdForImportLocation;
  }
    @Selector()
  static featureConfigurations(state: BaseStateModel) {
    return state.featureConfiguration;
  }
  @Selector()
  static TotalRecords(state: BaseStateModel) {
    return state.totalRecords;
  }

  @Selector()
  static Loading(state: BaseStateModel) {
    return state.loading;
  }

  @Selector()
  static IsConfigurationUpdated(state: BaseStateModel) {
    return state.isConfigurationUpdated;
  }

  @Selector()
  static IsCreated(state: BaseStateModel) {
    return state.isCreated;
  }

  @Selector()
  static IsUpdated(state: BaseStateModel) {
    return state.isUpdated;
  }

  @Selector()
  static IsDeleted(state: BaseStateModel) {
    return state.isDeleted;
  }

  @Selector()
  static BaseRoute(state: BaseStateModel) {
    return state.baseRoute;
  }

  @Selector()
  static SelectedMasterPlanForBreadcrumb(state: BaseStateModel) {
    return state.selectedMasterPlanForBreadcrumb;
  }

  @Selector()
  static SelectedPlanForBreadcrumb(state: BaseStateModel) {
    return state.selectedPlanForBreadcrumb;
  }

  @Selector()
  static SelectedJobForBreadcrumb(state: BaseStateModel) {
    return state.selectedJobForBreadcrumb;
  }

  @Selector()
  static SelectedValidatedJLData(state: BaseStateModel) {
    return state.validatedJLData;
  }
  
  @Selector()
  static SelectedLocationForBreadcrumb(state: BaseStateModel) {
    return state.selectedLocationForBreadcrumb;
  }

  @Selector()
  static SelectedServiceForBreadcrumb(state: BaseStateModel) {
    return state.selectedServiceForBreadcrumb;
  }
}
